import { today } from '../../utils/date';

type Alimento = {
  marca: string;
  nombre: string;
  peso: number;
  fechaCompra: string;
};

type FetchAlimento = {
  id: number;
  animal: string;
  marca: string;
  nombre: string;
  presentaciones: number[];
  cargaEnergetica: number | null;
  tabla: unknown | null;
  createdAt: string; // formato ISO (ej: "2025-08-08T16:10:03.025Z")
  updatedAt: string;
};

type detalleAlimento = {
  id: number;
  mascotaId: number;
  alimentoId: number;
  cantidad: number;
  fecha: string;
};

type AlimentoByMascota = {
  id: number;
  alimento: FetchAlimento;
  detalles: detalleAlimento[]; // historial de consumos o stocks
  total: number; // total de kilos o unidades consumidas
  current: number; // stock actual disponible
};

type AlimentoReq = {
  mascotas: number[];
  alimentoId: number;
  kilos: number;
  fechaCompra: Date;
  duracion?: number;
  contactoProveedor?: string;
  nombrePetShop?: string;
  modalidadCompra?: string;
};

type UpdateAlimento = {
  alimentoId: number;
  mascotas?: number[];
  kilos?: number;
};

type DeleteAlimento = {
  alimentoId: number;
  mascotas: number[];
};

type Pesaje = {
  peso: number | null;
  fecha_pesaje: string;
};

type PesajeReq = {
  mascotaId: string;
  peso: number;
  fecha_pesaje: string;
};

// export type ConsumoReq = {
//   idList: number[];
//   cargaEnergetica: number;
// };

// export type ConsumoRes = {
//   mascota: Pet;
//   consumo: number;
// }[];

export const getEmptyAlimento = (): Alimento => ({
  marca: '',
  nombre: '',
  peso: 0,
  fechaCompra: today,
});

export const getEmptyPesaje = (): Pesaje => ({
  peso: null,
  fecha_pesaje: today,
});

export type {
  Alimento,
  AlimentoReq,
  AlimentoByMascota,
  FetchAlimento,
  UpdateAlimento,
  DeleteAlimento,
  Pesaje,
  PesajeReq,
};
